import React from 'react';

interface StepWrapperProps {
  className?: string;
  stepNum: number;
  currentStep: number;
  currentProgress: number;
  children?: React.ReactNode;
}

const StepWrapper: React.FC<StepWrapperProps> = ({
  className = '',
  stepNum,
  currentStep,
  currentProgress,
  children,
}) => {
  const isActive = (currentStep === stepNum);
  const isVisited = (currentProgress >= stepNum);

  return (
    <div
      className={`mz-step-item-wrapper ${className}`}
      aria-hidden={!isActive}
    >
      {/* Render children when it's either active or already visited */}
      {(isActive || isVisited) && (
        children
      )}
    </div>
  );
};

export default StepWrapper;
